import { render, staticRenderFns } from "./form-description.vue?vue&type=template&id=569b341d&"
import script from "./form-description.vue?vue&type=script&lang=js&"
export * from "./form-description.vue?vue&type=script&lang=js&"
import style0 from "./form-description.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports